import phone_icon from "../Assets/SVG/phone_icon.svg";
import localisation_icon from "../Assets/SVG/localisation_icon.svg";
import mail_icon from "../Assets/SVG/mail_icon.svg";
import linkedin_icon from "../Assets/SVG/linkedin_icon.svg";
import instagram_icon from "../Assets/SVG/instagram_icon.svg";
import facebook_icon from "../Assets/SVG/facebook_icon.svg";
import youtube_icon from "../Assets/SVG/youtube_icon.svg";
import { useState } from "react";
import { sendContactData } from '../api/axios';
// import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import HeadingOfSection from "./HeadingOfSection";
import SuccesPopup from './SuccesPupup';
import { BiSolidMessageError } from "react-icons/bi";
import {BsSendCheckFill} from 'react-icons/bs'

const Contact = () => {
    const { t , i18n } = useTranslation();
    const isRTL = i18n.language === "ar";

    const [message, setMessage] = useState({
      name: "",
      email: "",
      phone_number: "",
      message: ""
  })
  const handleInput = (e) => {
      setMessage({ ...message, [e.target.id]: e.target.value })
      console.log(message);
  };
    
// Success popup state
const [done , setDone] = useState(false)
const [err , setErr] = useState(false)
const closeDone = () => { setDone(!done) }
const closeError = () => { setErr(!err) }

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await sendContactData(message);
    setMessage({
      name: "",
      email: "",
      phone_number: "",
      message: ""
    });
    setDone(true);
    console.log('Message sent successfully:', response);
  } catch (error) {
    setErr(true);
    console.error('Error sending message:', error);
  }
}
    
    return (
      <section className="w-full h-max flex flex-col items-center justify-center overflow-hidden">
        <div className="w-full py-10">
          <HeadingOfSection 
            header={t('contactpage.titlecontact')}
            span={t('contactpage.titlecontact2')}
            />
        </div>

        <div
          className={`w-full h-max bg-[#878787]/15 px-10 md:px-0 py-16 flex flex-col-reverse md:flex-row items-center md:items-start justify-center gap-6 ${isRTL ? 'rtl' : 'ltr'}`}
        >
          <span className="bg-white w-full md:w-[40%] p-6 h-max rounded-lg">
            <form className="flex flex-col gap-6" >
              <input
                onChange={handleInput}
                value={message.name}
                type="text"
                id="name"
                name="name"
                aria-describedby="helper-text-explanation"
                className="bg-[#F7F7F7] text-[#252525] font-Inter rounded-lg text-sm md:text-base block w-full p-2.5 placeholder-[#252525]  focus:outline-none"
                placeholder={t("contactpage.form.name")}
                required
              />
              <input
                onChange={handleInput}
                value={message.email}
                type="email"
                id="email"
                name="email"
                aria-describedby="helper-text-explanation"
                className="bg-[#F7F7F7] text-[#252525] font-Inter rounded-lg text-sm md:text-base block w-full p-2.5 placeholder-[#252525]  focus:outline-none"
                placeholder={t("contactpage.form.email")}
                required
              />
              <input
                onChange={handleInput}
                value={message.phone_number}
                type="text"
                id="phone_number"
                name="phone"
                aria-describedby="helper-text-explanation"
                className="bg-[#F7F7F7] text-[#252525] font-Inter rounded-lg text-sm md:text-base block w-full p-2.5 placeholder-[#252525]  focus:outline-none"
                placeholder={t("contactpage.form.phone")}
                required
    
              />

              <textarea
                onChange={handleInput}
                value={message.message}
                id="message"
                rows="4"
                name="message"
                className="bg-[#F7F7F7] text-[#252525] font-Inter rounded-lg text-sm md:text-base block w-full p-2.5 placeholder-[#252525]  focus:outline-none"
                placeholder={t("contactpage.form.message")}
                required
              ></textarea>

              <button
                className="self-center md:self-start text-white px-6 py-3 bg-[#C10100] w-max h-max rounded-lg"
                onClick={handleSubmit}
              >
                {t("contactpage.form.button")}
              </button>
            </form>
          </span>

          <span className="bg-white w-full md:w-[19rem] p-6 h-max rounded-lg">
            <a
              href={`tel:+21267783603`}
              className="flex flex-col md:flex-row items-center font-inter gap-3 py-4"
            >
              <img
                loading="lazy"
                className={`p-4 w-14 h-14 bg-[#F1F1F1] rounded-lg ${isRTL && 'rotate-180'}`}
                src={phone_icon}
                alt=""
              />
              <div className="flex flex-col items-start text-center md:text-start">
                <h6 className="font-Raleway text-sm font-semibold text-[#C10100] pb-[.5px]">
                  {t("contactpage.contactcards.card1")}
                </h6>
                <p className="text-xs text-[#4E4E4E]">
                  <a
                    href={`tel:+21267783603`}
                    dir="ltr"
                  >
                    {t("contactpage.contactcards.phone1")}
                  </a>
                </p>
              </div>
            </a>
            <a
              href={`mailto:${t("contactpage.contactcards.email1")}`}
              className="flex flex-col md:flex-row items-center font-inter gap-3 py-4"
            >
              <img
                loading="lazy"
                className="p-4 w-14 h-14 bg-[#F1F1F1] rounded-lg"
                src={mail_icon}
                alt=""
              />
              <div className="flex flex-col items-center justify-center md:text-start h-full">
                <h6 className="font-Raleway text-sm font-semibold text-[#C10100] pb-[.5px]">
                {t("contactpage.contactcards.card2")}
                </h6>
                <p className="text-xs text-[#4E4E4E]">
                 <a href={`mailto:${t("contactpage.contactcards.email1")}`}>{t("contactpage.contactcards.email1")}</a>
                </p>
              </div>
            </a>
            <a
              href="https://maps.app.goo.gl/LAeAyPii9y4em8Yt7"
              target="_blank"
              rel="noreferrer"
              className="flex flex-col md:flex-row items-center md:items-start font-Inter gap-3 py-4"
            >
              <img
                loading="lazy"
                className="py-4 px-5 w-14 h-14 bg-[#F1F1F1] rounded-lg"
                src={localisation_icon}
                alt=""
              />
              <div className="flex flex-col items-center md:items-start text-center md:text-start">
                <h6 className="font-Raleway text-sm font-semibold text-[#C10100] pb-[.5px]">
                {t("contactpage.contactcards.card3")}
                </h6>
                <span className="text-xs text-[#4E4E4E]">
                {t("contactpage.contactcards.adress")}
                </span>
              </div>
            </a>

            <p className="text-[#4E4E4E] font-Inter w-full text-center mt-[1.7rem]  md:text-2xl text-xl font-semibold">
            {t("contactpage.contactcards.socialmedia")}
            </p>

            <span className="w-full flex justify-center md:justify-center gap-6 md:gap-3 mt-5">
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 md:p-4 flex self-center bg-[#C10100] w-10 md:h-12 h-10 md:w-12 rounded-lg"
                  src={linkedin_icon}
                  alt=""
                />
              </Link>
              <Link
                href={
                  ""
                }
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 md:p-4 flex self-center bg-[#C10100] w-10 md:h-12 h-10 md:w-12 rounded-lg"
                  src={instagram_icon}
                  alt=""
                />
              </Link>
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 md:p-4 flex self-center bg-[#C10100] w-10 md:h-12 h-10 md:w-12 rounded-lg"
                  src={facebook_icon}
                  alt=""
                />
              </Link>
              <Link
                href={""}
                // target="-blank"
                className="cursor-pointer"
              >
                <img
                  loading="lazy"
                  className="p-2 md:p-4 flex self-center bg-[#C10100] w-10 md:h-12 h-10 md:w-12 rounded-lg"
                  src={youtube_icon}
                  alt=""
                />
              </Link>
            </span>
          </span>
        </div>

        <div className={`w-full h-12 xxl:h-20 flex gap-2 justify-center items-center border-t border-inputcolor/50 ${isRTL ? 'rtl' : 'ltr'}`}>
          <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-primary02'>{t('footer.title')} <a href='https://softcactus.ma' target='_blank' rel="noreferrer" className='text-primary font-bold'> SOFT CACTUS </a> </p>
          <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-primary02'> {t('footer.year')}</p>
        </div>
        {done && <SuccesPopup close={closeDone} icon={<BsSendCheckFill size={40} fill='#0f9b0f'/>} don={t('popup.succes')}/>}
        {err && <SuccesPopup close={closeError} icon={<BiSolidMessageError size={40} fill='#f00'/>} don={t('popup.error')} erorr/>}
      </section>
    );
};

export default Contact;
